import { isValidElement, cloneElement } from 'react'
import type { ReactNode, ReactElement } from 'react'
import { StickyFooter } from '../Shared'
import { Paragraph, Title } from '../Typography'

type Props = {
  title: string
  message: ReactNode
  extraMessage?: ReactNode
  button: JSX.Element
  extraButton?: ReactElement<{ className?: string }>
}

export function ErrorTemplate(props: Props) {
  return (
    <>
      <Title label={props.title} className="mb-8" />

      <Paragraph>{props.message}</Paragraph>

      {props.extraMessage}

      <StickyFooter>
        {props.button}

        {isValidElement(props.extraButton) &&
          cloneElement(props.extraButton, {
            className: 'ml-8',
          })}
      </StickyFooter>
    </>
  )
}
